import { Icon } from './icon';

/**
 * Mockup dashboard `KPI` tile. `accent` paints the dark eerie-black variant
 * (pink text); `trend` shows either the green "↗ alta" indicator (`up`) or
 * the amber "aguardando" pill (`warn`). `value` is the big 32px/900 number,
 * `label` the 12px caption, `delta` the small note under it.
 */
export function KpiCard({
  icon,
  value,
  label,
  delta,
  trend,
  accent = false,
}: {
  icon: string;
  value: string;
  label: string;
  delta?: string;
  trend?: 'up' | 'warn';
  accent?: boolean;
}): JSX.Element {
  const cardCls = accent
    ? 'bg-[var(--m-bg-inverse)] text-[var(--m-bg-alt)]'
    : 'bg-[var(--m-surface)]';
  const tileCls = accent
    ? 'bg-[rgba(255,53,53,0.20)] text-[var(--m-brand)]'
    : 'bg-[var(--m-bg-alt)] text-[var(--m-brand-press)]';
  const labelCls = accent ? 'text-[var(--m-smoothie)]' : 'text-[var(--m-fg-muted)]';
  const deltaCls = accent ? 'text-[rgba(255,236,236,0.55)]' : 'text-[var(--m-fg-subtle)]';

  return (
    <div className={`rounded-[var(--m-r-lg)] p-5 shadow-[var(--m-shadow-sm)] ${cardCls}`}>
      <div className="flex items-start justify-between">
        <span className={`inline-flex h-9 w-9 items-center justify-center rounded-[10px] ${tileCls}`}>
          <Icon name={icon} size={18} />
        </span>
        {trend === 'up' && (
          <span
            className="inline-flex items-center gap-1 text-[11px] font-bold"
            style={{ color: accent ? '#7BE5A8' : 'var(--m-success)' }}
          >
            <Icon name="trending-up" size={12} /> alta
          </span>
        )}
        {trend === 'warn' && (
          <span className="inline-flex items-center rounded-[var(--m-r-pill)] bg-[var(--m-pill-pending-bg)] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.04em] text-[var(--m-pill-pending-fg)] shadow-[var(--m-shadow-sm)]">
            aguardando
          </span>
        )}
      </div>
      <div className="mt-4 text-[32px] font-black leading-none tracking-[-0.02em]">{value}</div>
      <div className={`mt-2 text-[12px] font-medium ${labelCls}`}>{label}</div>
      {delta && <div className={`mt-0.5 text-[11px] ${deltaCls}`}>{delta}</div>}
    </div>
  );
}
